import window from 'window';

import { loadModules } from './foundation/moduleInitializer';
import { usageType } from './feature/usagetype/usagetype';

const app = (function() {
    const modules = [
        usageType
    ];

    return {
        init() {
            loadModules(modules);
        }
    };
})();

window.addEventListener('DOMContentLoaded', app.init);